module.exports = __webpack_public_path__ + "img/thumbnail-list-item-feetscare.b51770d3.webp";